import {
  EDIT_PARAMS,
  GET_PARTICIPANT_PRIVACY_ERROR,
  GET_PARTICIPANT_PRIVACY_REQUEST,
  GET_PARTICIPANT_PRIVACY_SUCCESS,
  GET_PARTICIPANT_TERM_ERROR,
  GET_PARTICIPANT_TERM_REQUEST,
  GET_PARTICIPANT_TERM_SUCCESS,
  GET_USER_PRIVACY_ERROR,
  GET_USER_PRIVACY_REQUEST,
  GET_USER_PRIVACY_SUCCESS,
  GET_USER_TERM_ERROR,
  GET_USER_TERM_REQUEST,
  GET_USER_TERM_SUCCESS,
  GET_SUPPORT_ERROR,
  GET_SUPPORT_REQUEST,
  GET_SUPPORT_SUCCESS,
  GET_LANGUAGES_REQUEST,
  GET_LANGUAGES_SUCCESS,
  GET_LANGUAGES_ERROR,
  GET_TRANSLATIONS_SUCCESS,
} from "../actions";
import { getSavedLanguage } from "../utils/translation";
import { languages as defaultLanguages } from "../static/languages";

const initialState = {
  language: getSavedLanguage(),
  isLoadingPrivacy: false,
  isLoadingTerm: false,
  isloadingSupport: false,
  privacy: null,
  terms: null,
  support: null,
  languages: defaultLanguages,
  isloadingLanguages: false,
  translations: [],
};

export const uiReducer = (state = initialState, { payload, type } = {}) => {
  const { user_type, version, language } = payload || {};
  switch (type) {
    case EDIT_PARAMS:
      return {
        ...state,
        language: language,
        version: version,
        user_type: user_type,
      };
    case GET_PARTICIPANT_PRIVACY_REQUEST:
    case GET_USER_PRIVACY_REQUEST:
      return {
        ...state,
        isLoadingPrivacy: true,
      };
    case GET_PARTICIPANT_TERM_REQUEST:
    case GET_USER_TERM_REQUEST:
      return {
        ...state,
        isLoadingTerm: true,
      };
    case GET_PARTICIPANT_PRIVACY_ERROR:
    case GET_USER_PRIVACY_ERROR:
      return {
        ...state,
        isLoadingPrivacy: false,
      };
    case GET_PARTICIPANT_TERM_ERROR:
    case GET_USER_TERM_ERROR:
      return {
        ...state,
        isLoadingTerm: false,
      };
    case GET_USER_PRIVACY_SUCCESS:
    case GET_PARTICIPANT_PRIVACY_SUCCESS:
      return {
        ...state,
        isLoadingPrivacy: false,
        privacy: payload,
      };
    case GET_PARTICIPANT_TERM_SUCCESS:
    case GET_USER_TERM_SUCCESS:
      return {
        ...state,
        isLoadingTerm: false,
        terms: payload,
      };
    case GET_SUPPORT_REQUEST:
    case GET_SUPPORT_ERROR:
      return {
        ...state,
        isloadingSupport: false,
      };
    case GET_SUPPORT_SUCCESS:
      return {
        ...state,
        isloadingSupport: false,
        support: payload,
      };
    case GET_LANGUAGES_REQUEST:
      return {
        ...state,
        isloadingLanguages: true,
      };
    case GET_LANGUAGES_SUCCESS:
      return {
        ...state,
        isloadingLanguages: false,
        languages: payload,
      };
    case GET_LANGUAGES_ERROR:
      return {
        ...state,
        isloadingLanguages: false,
      };
    case GET_TRANSLATIONS_SUCCESS:
      return {
        ...state,
        translations: payload,
      };
    default:
      return { ...state };
  }
};
